import Draft from "draft-js";
import { createSelection } from "./createSelection";

/**
 * Get a list of selections that match a specific entity key
 */
export const getEntitySelections = (
  content: Draft.ContentState,
  entityKey: string | null,
): Draft.SelectionState[] => {
  const ranges: Draft.SelectionState[] = [];
  if (entityKey) {
    content.getBlocksAsArray().forEach(block => {
      const blockKey = block.getKey();
      block.findEntityRanges(
        character => {
          const characterEntityKey = character.getEntity();
          return characterEntityKey === entityKey;
        },
        (start, end) => {
          ranges.push(
            createSelection({
              anchorKey: blockKey,
              anchorOffset: start,
              focusKey: blockKey,
              focusOffset: end,
              isBackward: false,
              hasFocus: false,
            }),
          );
        },
      );
    });
  }

  return ranges;
};
